import TimeRange from "@/types/time-range";
import {
  api,
  PrecipitationMapLayerData,
  PrecipitationMapLayerDataObservations,
} from "@/lib/api";
import { parseStandardDataDimensions } from "@/lib/dimensions/helpers";
import { WmsLayerData } from "@/features/shared/widgets/map/layers/wms-layer/wms-layer-data-loader";

export type PrecipitationLayerData = {
  forecast: WmsLayerData;
  observations: WmsLayerData;
};

export default class PrecipitationLayerDataLoader {
  private dashboardId;
  private mapLayerId;

  constructor(dashboardId: string, mapLayerId: string) {
    this.dashboardId = dashboardId;
    this.mapLayerId = mapLayerId;
  }

  async loadLayerData(timeRange: TimeRange): Promise<PrecipitationLayerData> {
    const response = (
      await api.published.getPublishedMapLayerData(
        this.dashboardId,
        this.mapLayerId,
        timeRange.timeStart.toISOString(),
        timeRange.timeEnd.toISOString(),
      )
    ).data as PrecipitationMapLayerData;

    return {
      forecast: this.convertData(response.forecast),
      observations: this.convertData(response.observations),
    };
  }

  private convertData(data: PrecipitationMapLayerDataObservations): WmsLayerData {
    return {
      dimensions: parseStandardDataDimensions(data.dimensions),
      extent: data.bounding_box && {
        north: data.bounding_box.north_bound_latitude,
        east: data.bounding_box.east_bound_longitude,
        south: data.bounding_box.south_bound_latitude,
        west: data.bounding_box.west_bound_longitude,
      },
    };
  }
}
